export default "__VITE_ASSET__DvHUmdEW__"